module.exports = __webpack_public_path__ + "img/alg.031cf249.png";